import { CUSTOMER_SERVICE_PERMISSIONS, CUSTOMER_SERVICE_PERMISSION_LABELS, type CustomerServicePermission } from '@cpm/shared';

export function ServicePermissionsPicker({ value, onChange, disabled = false }: {
  value: CustomerServicePermission[]; onChange: (value: CustomerServicePermission[]) => void; disabled?: boolean;
}) {
  return <fieldset disabled={disabled} className="space-y-3">
    <legend className="text-sm font-medium">Service management permissions</legend>
    <p className="text-sm text-slate-500">Applies across this customer account. Each subscription's plan, limits and provider restrictions still apply. Unchecked services keep the member's existing portal access.</p>
    <div className="grid gap-3 sm:grid-cols-2">{CUSTOMER_SERVICE_PERMISSIONS.map((permission) => <label key={permission} className="flex items-center gap-2 text-sm">
      <input type="checkbox" checked={value.includes(permission)} onChange={(e) => onChange(e.target.checked ? [...value, permission] : value.filter((entry) => entry !== permission))} />
      {CUSTOMER_SERVICE_PERMISSION_LABELS[permission]}
    </label>)}</div>
    <p className="text-sm text-slate-500">These permissions do not grant user administration or GitHub connection management. Changing permissions signs the member out.</p>
  </fieldset>;
}

export function ServicePermissionsSummary({ value }: { value: readonly CustomerServicePermission[] }) {
  return <p className="text-sm text-slate-500">Service management: {value.length ? value.map((permission) => CUSTOMER_SERVICE_PERMISSION_LABELS[permission]).join(', ') : 'None delegated'}</p>;
}
